// GAVION commissions: Paramètres → Forfaits and Plans de commission.
export const commissionsSettingsEn = {
  saved: "Saved",
  edit: "Edit",
  edit_named: "Edit %{name}",
  save: "Save",
  cancel: "Cancel",
  inactive: "inactive",
  both_lines: "Both lines",
  fields: {
    code: "Code",
    name: "Name",
    line: "Line",
    tier: "Tier",
    monthly_price: "Price per month ($)",
    unit_price: "Unit price ($)",
    billing: "Billing",
    included: "Included (minutes, users, agents, quotes)",
    position: "Order",
    active: "Active",
  },
  errors: {
    required: "Required.",
    code: "Lower-case letters, digits and _ only (60 at most).",
    amount: "Enter an amount between 0 and 100,000.",
    int: "Enter a whole number.",
    duplicate_code: "This code already exists.",
    pct: "Enter a percentage between 0 and 100.",
    date: "Enter a date.",
    order: "The end must follow the start.",
    overlap: "This person already has a plan for that period.",
    months: "Enter a number of months between 0 and 120.",
    days: "Enter a number of days between 0 and 3,650.",
    sources: "Choose at least one source.",
    version_date:
      "The new version starts this month or later, after the current plan's start.",
    long: "Text too long.",
  },
  packages: {
    title: "Packages",
    intro:
      "The package and add-on catalog. A subscription keeps the price of the day it was entered: changing a price here changes no month already billed.",
  },
  package: { title: "Packages", add: "Add a package" },
  addon: { title: "Add-ons", add: "Add an add-on" },
  discount: {
    title: "Annual discount",
    label: "Discount for an annual payment (%)",
    hint: "Used to suggest the annual amount of a new subscription.",
  },
  plans: {
    title: "Commission plans",
    intro: "One plan per person and period. No plan, no commission or bonus.",
    empty: "No commission plan.",
    add: "Add a plan",
    edit_title: "Edit the plan",
    save: "Save the plan",
    new_version: "New version",
    new_version_named: "New version of %{name}'s plan from %{from}",
    new_version_title: "New version of the plan",
    new_version_save: "Create the new version",
    new_version_hint:
      "This plan is in force: its past rates never change. The current plan ends the day before the chosen date and a new row starts that day.",
    delete_locked: "Already paid on: cannot be deleted",
    delete: "Delete",
    confirm_delete: "Delete this commission plan?",
    edit_named: "Edit %{name}'s plan from %{from}",
    delete_named: "Delete %{name}'s plan from %{from}",
    from_to: "from %{from} to %{to}",
    from_open: "since %{from}",
    summary:
      "%{rate_initial} % × %{months} months, then %{rate_after} % · share %{split} % · bonus %{bonus}",
    grid: "all %{full} % · appointment only %{appt} % · appointment + demo %{appt_demo}",
    to_decide: "To decide",
    grid_title: "Who is paid what, by who conducts each step",
    vacation_pay_help:
      "0 = not computed (counted separately by payroll, for now). Otherwise 4%, 6% after 3 years of continuous service (LNT art. 74): shown on every statement for payroll, never added to the total.",
    employment_end_on: "employment ends %{date}",
    fields: {
      sales_id: "Person",
      effective_from: "In force from",
      effective_to: "Until (empty: open-ended)",
      rate_initial_pct: "Rate of the first months (%)",
      initial_months: "Months at the first rate",
      rate_after_pct: "Rate afterwards (%)",
      full_share_pct: "Appointment, demo and close (%)",
      demo_by_other_split_pct: "Close, demo by someone else (%)",
      appointment_bonus: "Appointment only: bonus ($)",
      appointment_share_pct: "Appointment only: share of the commission (%)",
      appointment_demo_share_pct:
        "Appointment and demo, close by someone else (%, empty: To decide)",
      bonus_window_days: "Bonus window (days)",
      vacation_pay_pct: "Vacation pay (%)",
      eligible_sources: "Eligible sources",
      employment_end: "End of employment (empty: employed)",
      note: "Note",
    },
  },
};
